import * as React from 'react';
import Strings from '../../globals/Strings';
import EventHandlingModalContainer from '../EventHandlingModal/EventHandlingModalContainer';
import {TscButtonType} from '@techsmith/tsc-cloud-style-guide';

export default ({onClose}: LeaveReviewModalProps) => {
   return <EventHandlingModalContainer visible={true}
      defaultOnClose={onClose}
      title={Strings.labels.leaveReview}
      closeContent={Strings.labels.cancel}
      confirmContent={Strings.labels.leave}
      confirmButtonType={TscButtonType.destructive}
      dismissContent={Strings.labels.cancel}
      testId="leave-review-modal">
      {Strings.labels.confirmLeaveText}
   </EventHandlingModalContainer>;
};

export interface LeaveReviewModalProps {
   onClose(): void;
}
